import React, { useEffect, useState } from "react";
import overdraftLoan from "../assets/main_banner_main_business_.webp";
import goldLoan from "../assets/main_banner_main_gold_1.webp";
import houseLoan from "../assets/main_banner_main_home_.webp";
import vehicleLoan from "../assets/main_banner_main_vehicle_.webp";

import overdraftLoanmobile from "../assets/main_banner_main_business_mobile.webp";
import goldLoanmobile from "../assets/main_banner_main_gold_mobile.webp";
import houseLoanmobile from "../assets/main_banner_main_home_mobile.webp";
import vehicleLoanmobile from "../assets/main_banner_main_vehicle_mobile.webp";

import useLazyImage from "./lazyloader/LazyImage";

const banners = [
  {
    image: vehicleLoan,
    mobileImage: vehicleLoanmobile,
    title: "Drive Your Dream with <br/> Easy Vehicle Loans",
    description:
      "Fast approvals, low interest, and flexible repayment options for two & four-wheelers.",
    button: "Apply Now",
    textColor: "#fff",
    btnColor: "#fff",
    btnTextColor: "#4B4B4B",
  },
  {
    image: goldLoan,
    mobileImage: goldLoanmobile,
    title: "India's Trusted Choice for <br /> Instant Gold & Personal Loans",
    description:
      "Unlock funds in minutes with flexible repayment options, minimal paperwork, and 100% secure storage.",
    button: "Apply Now",
    textColor: "#2353A6",
    btnColor: "#1E50A2",
  },
  {
    image: houseLoan,
    mobileImage: houseLoanmobile,
    title: "Your Dream Home, Now <br /> Within Reach",
    description:
      "Affordable housing loans with easy EMIs, attractive interest rates, and long tenures.",
    button: "Apply Now",
    textColor: "#2353A6",
    btnColor: "#1E50A2",
  },
  {
    image: overdraftLoan,
    mobileImage: overdraftLoanmobile,
    title: "Fuel Your Business <br /> Growth with Shubh Paisa",
    description:
      "Flexible business loans designed for SMEs, startups, and entrepreneurs to expand faster.",
    button: "Apply Now",
    textColor: "#2353A6",
    btnColor: "#1E50A2",
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const bannerImage = isMobile
    ? banners[current].mobileImage
    : banners[current].image;

  const { ref, loadedSrc } = useLazyImage(bannerImage);

  const totalSlides = banners.length;
  const maxDots = 3;

  const getDotIndices = () => {
    if (totalSlides <= maxDots) {
      return Array.from({ length: totalSlides }, (_, i) => i);
    }
    return [
      (current - 1 + totalSlides) % totalSlides,
      current,
      (current + 1) % totalSlides,
    ];
  };

  const dotIndices = getDotIndices();

  return (
    <section className="w-100 position-relative">
      <div className="container-fluid p-0">
        <div
          ref={ref}
          className="position-relative w-100 d-flex hero-banner"
          style={{
            minHeight:
              windowWidth <= 768
                ? "550px"
                : windowWidth <= 1024
                ? "320px"
                : windowWidth <= 1600
                ? "600px"
                : "750px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundImage: loadedSrc ? `url(${loadedSrc})` : "none",
            transition: "background-image 0.5s ease-in-out",
            alignItems: windowWidth <= 768 ? "flex-start" : "center",
            paddingTop: windowWidth <= 768 ? "40px" : "0",
          }}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-1"></div>
              <div
                className="col-10"
                style={{
                  position: "relative",
                  zIndex: 2,
                  width:
                    windowWidth <= 768
                      ? "90%"
                      : windowWidth <= 1024
                      ? "42%"
                      : "45%",
                  textAlign: windowWidth <= 768 ? "center" : "left",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: windowWidth <= 768 ? "center" : "flex-start",
                }}
              >
                <div className="text-white text-start">
                  <h1
                    className="fw-semibold mb-2"
                    style={{
                      fontSize:
                        windowWidth <= 768
                          ? "22px"
                          : windowWidth <= 1024
                          ? "24px"
                          : "35px",
                      textAlign: "left",
                      lineHeight: "1.2",
                      fontWeight: "700",
                      color: banners[current].textColor,
                    }}
                    dangerouslySetInnerHTML={{
                      __html: banners[current].title,
                    }}
                  ></h1>
                  <p
                    className="mb-2"
                    style={{
                      fontSize:
                        windowWidth <= 768
                          ? "16px"
                          : windowWidth <= 1024
                          ? "16px"
                          : "18px",
                      textAlign: "left",
                      maxWidth: "550px",
                      fontWeight: "300",
                      color: banners[current].textColor,
                    }}
                  >
                    {banners[current].description}
                  </p>
                  <button
                    style={{
                      padding: isMobile ? "10px 20px" : "12px 28px",
                      fontSize: isMobile ? "14px" : "16px",
                      backgroundColor: banners[current].btnColor,
                      color: banners[current].btnTextColor || "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    {banners[current].button}
                  </button>
                </div>
              </div>
              <div className="col-1"></div>
            </div>
          </div>

          <div style={styles.indicatorContainer}>
            {Array.from({ length: 4 }).map((_, index) => {
              const realIndex = index % banners.length;

              return (
                <button
                  key={index}
                  onClick={() => setCurrent(realIndex)}
                  className={`dot-indicator ${
                    current === realIndex ? "active" : ""
                  }`}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  indicatorContainer: {
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    zIndex: 5,
  },
};
